// Centralized "session expired → go log in" navigation.
//
// Called by the API client whenever ANY request comes back 401. This is the
// single source of truth for re-auth: individual loaders/components no longer
// need to special-case 401, because the moment a request observes one the
// whole window is sent to the login flow.
//
// A full-document navigation (window.location, not SvelteKit goto) is
// deliberate. It tears down every in-memory cache (home cache, app-cache,
// identity store) so the post-login reload starts from a clean slate and
// can't replay a stale 401 into a redirect loop. The login route itself then
// bounces to Okta and the callback returns the user to `return_to`.

let redirecting = false;

/**
 * Navigate the top window to the login flow, preserving the current path as
 * `return_to`. No-op when there's no window (SSR / unit tests), when we're
 * already on an `/auth/*` page, or when a redirect is already underway —
 * concurrent 401s from parallel requests must not thrash the navigation.
 */
export function redirectToLogin(): void {
  if (typeof window === 'undefined') return;
  if (redirecting || window.location.pathname.startsWith('/auth/')) return;
  redirecting = true;
  const returnTo = window.location.pathname + window.location.search;
  window.location.assign(`/auth/login?return_to=${encodeURIComponent(returnTo)}`);
}
